import account from "../services/accountServices";
import axios from "axios";
import { toast } from "react-toastify";

function setJwt(jwt) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
}


axios.interceptors.response.use(null, error => {
    console.log('ddd',error);
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;    
    if (error.response && error.response.status == 401) {        
        account.logout();
        
        toast.error("حساب شما منقضی شده است مجددد وارد شوید");
    }
    else if (expectedError==undefined || !expectedError) {        
        console.log("Error", error);
        toast.error("خطا در ارتباط سرور");
    }
    return Promise.reject(error);
});

const handleChange = (event, form,setForm) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    setForm({ ...form, [name]: value });
  };

export default { 
    handleChange,
    axiosInstance: axios,
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    setJwt,
};
